// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__bO-ZE","content":"RecentSearches_content__FcgX9"};